
const OverviewHelp = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          CloudOps Overview
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          The CloudOps Overview provides a centralized dashboard to monitor your AWS infrastructure health,
          cost trends, compliance status, and operational metrics across all connected environments.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Platform Health
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Monitor the overall health of your cloud infrastructure at a glance.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Health Score:</strong> Aggregated metric showing overall platform stability</li>
          <li><strong>Active Incidents:</strong> Current issues requiring attention</li>
          <li><strong>Uptime:</strong> Platform availability percentage</li>
          <li><strong>Resource Status:</strong> Overview of compute, storage, and network resources</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Cost Trends
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Track spending patterns and identify cost optimization opportunities.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Monthly Spend:</strong> Current month costs vs. previous periods</li>
          <li><strong>Forecast:</strong> Projected spend based on current usage trends</li>
          <li><strong>Top Services:</strong> Highest cost contributors</li>
          <li><strong>Budget Status:</strong> Spending against defined budgets</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Compliance & Guardrails
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Monitor adherence to security policies and operational best practices.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Compliance Score:</strong> Percentage of resources meeting policy requirements</li>
          <li><strong>Active Rules:</strong> Number of governance rules being enforced</li>
          <li><strong>Violations:</strong> Resources not meeting compliance standards</li>
          <li><strong>Tagging Coverage:</strong> Percentage of resources properly tagged</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Environment Status
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          View the operational status of all connected AWS environments.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Active Endpoints:</strong> Number of connected AWS accounts</li>
          <li><strong>Health Checks:</strong> Status of automated monitoring across environments</li>
          <li><strong>Access Management:</strong> User access and permission overview</li>
          <li><strong>Region Distribution:</strong> Geographic distribution of resources</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Quick Actions
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Navigate to key CloudOps sections directly from the overview.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>View FinOps:</strong> Detailed cost analysis and optimization</li>
          <li><strong>Check Anomalies:</strong> Investigate cost or performance anomalies</li>
          <li><strong>Review Guardrails:</strong> Manage compliance and governance rules</li>
          <li><strong>Manage Environments:</strong> Configure AWS environments and access</li>
        </ul>
      </div>

    </>
  );
};

export default OverviewHelp;
